import React from 'react';
import { CheckCircle2, Clock, Target, Lock } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
export function GrowthPartnerBanner() {
  const {
    t
  } = useLanguage();
  const differentiators = [{
    icon: CheckCircle2,
    color: 'text-cyan-400',
    text: t.growth_diff1
  }, {
    icon: Clock,
    color: 'text-kinetic-yellow',
    text: t.growth_diff2
  }, {
    icon: Target,
    color: 'text-purple-400',
    text: t.growth_diff3
  }, {
    icon: Lock,
    color: 'text-white',
    text: t.growth_diff4
  }];
  return <section className="bg-gradient-to-r from-cyan-950 via-black to-purple-950 border-y border-cyan-500/20 py-14 sm:py-20 px-5 sm:px-6" data-id="element-93" data-mp="16ux0qnw2jdfo">
      <div className="container mx-auto grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-12" data-id="element-94" data-mp="1bv1dc2tuvo0m">
        <div data-id="element-95" data-mp="1gpymd9r4xxdi">
          <span className="text-cyan-400 text-xs uppercase tracking-widest inline-flex items-center gap-2" data-id="element-96" data-mp="1gpoxxqlqny9x">
            <span className="w-2 h-2 rounded-full bg-cyan-400 inline-block shrink-0" data-id="element-97" data-mp="2s76pzstyj9gm" />
            {t.growth_label}
          </span>
          <h2 className="font-heading text-3xl sm:text-4xl font-black text-white mt-4" data-id="element-98" data-mp="2trmwtz8xzdbl">
            {t.growth_heading}
          </h2>
          <p className="text-white/60 mt-4 text-base max-w-md" data-id="element-99" data-mp="2ouearnkoap52">{t.growth_body}</p>
        </div>

        <div data-id="element-100" data-mp="2kq6m1qe7t96u">
          <div className="space-y-4 sm:space-y-5" data-id="element-101" data-mp="2ku44sawvryq7">
            {differentiators.map(({
            icon: Icon,
            color,
            text
          }) => <div key={text} className="flex items-start gap-3 sm:gap-4" data-id="element-102" data-mp="2atk1z3tpqm5v">
                <Icon className={`w-5 h-5 shrink-0 mt-0.5 ${color}`} data-id="element-103" data-mp="2avwq5yq2dsrd" />
                <span className="text-white/80 text-sm sm:text-base" data-id="element-104" data-mp="261k7hqwewlgo">{text}</span>
              </div>)}
          </div>

          <a href="#consulta" className="bg-white text-black font-bold px-6 py-3 rounded mt-6 sm:mt-8 inline-block hover:brightness-95 transition-all duration-200 text-sm sm:text-base" data-id="element-105" data-mp="211o1xn82glz0">
            {t.growth_cta}
          </a>
        </div>
      </div>
    </section>;
}